import React from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import Question from "./Question";
import UnselectedQuestion from "./UnSelectedQuestion";
import CurateQuestion from "./CurateQuestion";

function QuestionList({
  questions,
  handleQuestionTreeApi,
  expandedKeys,
  selected,
  parentQuestion = null,
  position = null,
  indentLevel = null,
  isCurate,
  disabled,
}) {
  const getPosition = (_, index) => {
    if (position === null) return index + 1 + ".";
    return position + (index + 1) + ".";
  };

  const getIndentLevel = (item, index) => {
    if (isCurate && item.value?.original?.itemExtra?.curate?.show === 1) {
      if (indentLevel === null) return index + 1 + ".";
      return indentLevel + (index + 1) + ".";
    }
    if (isCurate && item.value?.original?.itemExtra?.curate?.show === 0)
      return indentLevel + "";

    if (indentLevel === null) return index + 1 + ".";
    return indentLevel + (index + 1) + ".";
  };

  // Drag & Drop
  const onBeforeCapture = (result) => {
    // Collapse all children of a parent question
    handleQuestionTreeApi({
      type: "COLLAPSE_QUESTIONS",
      payload: {
        key: result.draggableId,
      },
    });
  };
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    handleQuestionTreeApi({
      type: "DROP_QUESTION",
      payload: { key: selected.split("#")[0], index: result.destination.index },
    });
  };

  return (
    <React.Fragment>
      <DragDropContext onBeforeCapture={onBeforeCapture} onDragEnd={onDragEnd}>
        <Droppable droppableId={questions[0]?.parentKey ?? "root"}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {questions.map((question, index) => (
                <div key={question.key}>
                  {isCurate &&
                  question.value?.original?.itemExtra?.curate?.show ===
                    0 ? null : isCurate &&
                    question.value?.original?.itemExtra?.curate?.show === 1 ? (
                    <CurateQuestion
                      indentLevel={getIndentLevel(question, index)}
                      selected={selected}
                      questionLeaf={question}
                      disabled={disabled}
                      index={index}
                      isExpanded={expandedKeys.includes(question.key)}
                      handleQuestionTreeApi={handleQuestionTreeApi}
                      isCurate={isCurate}
                    />
                  ) : selected.split("#")[0] === question.key ? (
                    <Question
                      index={index}
                      questionLeaf={question}
                      position={getPosition(question, index)}
                      indentLevel={getIndentLevel(question, index)}
                      selected={selected}
                      isExpanded={expandedKeys.includes(question.key)}
                      previousQuestion={questions[index - 1]}
                      parentQuestion={parentQuestion}
                      handleQuestionTreeApi={handleQuestionTreeApi}
                      isCurate={isCurate}
                      disabled={disabled}
                    />
                  ) : (
                    <UnselectedQuestion
                      index={index}
                      indentLevel={getIndentLevel(question, index)}
                      questionLeaf={question}
                      disabled={disabled}
                      isExpanded={expandedKeys.includes(question.key)}
                      handleQuestionTreeApi={handleQuestionTreeApi}
                      position={getPosition(question, index)}
                    />
                  )}

                  {expandedKeys.includes(question.key) ? (
                    <QuestionList
                      questions={question.children}
                      handleQuestionTreeApi={handleQuestionTreeApi}
                      expandedKeys={expandedKeys}
                      selected={selected}
                      parentQuestion={question}
                      position={getPosition(question, index)}
                      indentLevel={getIndentLevel(question, index)}
                      isCurate={isCurate}
                      disabled={disabled}
                    />
                  ) : null}
                </div>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </React.Fragment>
  );
}

export default QuestionList;
